import { useCallback, useEffect, useState } from "react";
import { FootprintsResponse } from "./models";
import { useCustomAlert } from "../alerts";
import useFetchAndTrace from "../fetchWithTrace";
import settings from "../../../constants/settings";

export default function useSearchFootprints() {
  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();
  const [searching, setSearching] = useState(false);
  const [footprintsResponse, setFootprintsResponse] =
    useState<FootprintsResponse | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const errorHandler = useCallback(() => {
    setSearching(false);
    customAlert("Failed to search parts");
  }, [customAlert]);

  const searchHandler = useCallback(async (response: Response) => {
    setSearching(false);
    if (response.ok) {
      setFootprintsResponse((await response.json()) as FootprintsResponse);
    } else {
      throw Error("Failed to search parts");
    }
  }, []);

  const searchFootprints = useCallback(() => {
    setSearching(true);
    void fetchAndTrace(
      `${settings.api_url}/footprints/search?page=${page}`,
      searchHandler,
      errorHandler,
      {
        body: JSON.stringify({
          search_term: searchTerm,
          search_flashpcb_library_footprints: true,
        }),
        method: "PUT",
      },
    );
  }, [errorHandler, fetchAndTrace, page, searchHandler, searchTerm]);

  useEffect(() => {
    searchFootprints();
  }, [searchFootprints]);

  return {
    searching,
    footprintsResponse,
    setPage,
    setSearchTerm,
  };
}
